import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import ParticlesComponent from "./Particles";
import { ResearchPublications } from "../data/data";
import "../styles/research.css"



function Research({isDarkMode}) {
    const research = ResearchPublications;

    return (
        <div className="research-section">
            <ParticlesComponent isDarkMode={isDarkMode} id="tsparticles" />

            <h4 className={`research-title ${isDarkMode ? 'dark' : 'light'}`}>
                Research Publications
            </h4>

            <div className="research-container">
                {research.map((item, index) => (
                    <Card className={`research-card ${isDarkMode ? 'dark' : 'light'}`} key={index}>
                        <Card.Body>
                            <Card.Title className={`research-title-text ${isDarkMode ? 'dark' : 'light'}`}>
                                {item.title}
                            </Card.Title>
                            <Card.Text className={`research-description ${isDarkMode ? 'dark' : 'light'}`}>
                                <strong>Authors:</strong> {item.authors.join(", ")}<br />
                                <strong>Journal:</strong> {item.journal}<br />
                                <strong>Year:</strong> {item.year}<br />
                                <strong>Description:</strong> {item.description}
                            </Card.Text>
                            <Button
                                href={item.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                variant="outline-primary"
                            >
                                View Paper
                            </Button>
                        </Card.Body>
                    </Card>
                ))}
            </div>

        </div>
    );
}
export default Research;